/**
 * Removes leading "The report says..." filler from LLM-normalized report claims (display only).
 * @param {string|null|undefined} text
 * @returns {string}
 */
export function stripReportSaysPrefix(text) {
    if (!text || typeof text !== 'string') return '';
    return text.replace(/^\s*The report says\s*[.:]?\s*/i, '').trim();
}
